// src/components/custom-amount-modal.component.tsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface EnterAmountModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: (amount: number) => void;
}

const EnterAmountModal: React.FC<EnterAmountModalProps> = ({
  show,
  onClose,
  onConfirm,
}) => {
  const [customAmount, setCustomAmount] = useState<string>('');

  const formatAmount = (value: string): string => {
    // Remove any invalid characters, keep only digits and one dot
    let sanitizedValue = value.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point exists
    const parts = sanitizedValue.split('.');
    if (parts.length > 2) {
      sanitizedValue = `${parts[0]}.${parts[1]}`;
    }

    // Format integer part with thousands separator
    const [integerPart, decimalPart] = sanitizedValue.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    setCustomAmount(formatAmount(rawValue));
  };

  const handleSubmit = () => {
    const numericValue = parseFloat(customAmount.replace(/,/g, ''));
    if (isNaN(numericValue) || numericValue <= 0) {
      alert('Please enter a valid amount');
      return;
    }
    onConfirm(numericValue);
    setCustomAmount('');
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title className="greenColour">Enter Amount</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <div className="input-group">
              <span className="input-group-text">$</span>
              <Form.Control
                className="greenColour"
                type="text"
                value={customAmount}
                onChange={handleChange}
                placeholder="0.00"
              />
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="greenButton w-100 mt-4" onClick={handleSubmit}>
          Next
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EnterAmountModal;